import { IconButton } from '@material-ui/core'
import { Close } from '@material-ui/icons'
import { useEffect } from 'react'
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { updateUserInfo } from '../../actions/userActions'
import { USER_UPDATE_INFO_RESET } from '../../constants/userConstants'

const HelpCenterBar = () => {
  const history = useHistory()
  const dispatch = useDispatch()

  const { success } = useSelector(
    (state: RootStateOrAny) => state.userUpdateInfo
  )

  useEffect(() => {
    if (success) {
      dispatch({ type: USER_UPDATE_INFO_RESET })
    }
  }, [success, dispatch])

  const handleClose = () => {
    const user = {
      showHelpCenter: false,
    }

    dispatch(updateUserInfo(user))
  }

  return (
    <div className="flex justify-center blue-bg fs14 p-14 relative hide-680">
      <div>
        Welcome to MyQuality - explore our onboarding materials to get
        started!&nbsp;
      </div>

      <div
        className="link"
        onClick={() => history.push('/myquality/help-center')}
      >
        {' '}
        Learn more
      </div>

      <IconButton
        style={{ position: 'absolute', right: 15, top: 8 }}
        onClick={handleClose}
      >
        <Close style={{ color: 'white' }} />
      </IconButton>
    </div>
  )
}

export default HelpCenterBar
